<template>
  <div class="artist-section relative">
    <VPLabel label="Artists" />
    <template
      v-for="artist in artists"
      :key="artist.listId"
    >
      <ArtistRow
        :form-id="artist.formId"
        :artist="artist.artist"
        :list-id="artist.listId"
        @remove="remove"
      />
    </template>
    <VPButton
      class="mt-3 pl-4 pr-4"
      size="md"
      height="2rem"
      @click="add"
    >
      Add Artist
    </VPButton>
  </div>
</template>

<script setup lang="ts">
import { defineEmits } from 'vue';
import VPButton from '@/components/form/VPButton.vue';
import VPLabel from '@/components/form/VPLabel.vue';
import ArtistRow from '@/components/announce-modal/ArtistRow.vue';
import type { AnnounceArtist } from '@/generated/graphql';

interface Props {
  artists: {
    listId: number;
    formId: string;
    artist: AnnounceArtist;
  }[];
}

defineProps<Props>();

const emit = defineEmits<{
  (e: 'add'): void;
  (e: 'remove', listId: number): void;
}>();

const add = () => emit('add');
const remove = (listId: number) => emit('remove', listId);
</script>
